import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import AddUsers from "./AddUsers";
import UserCard from "../../utils/components/UserCard";

import "../../../styles/components/evs/modals/AddGroup.scss";
import friends from "../../../styles/images/friends.svg";
import camera from "../../../styles/images/camera.svg";
import plus from "../../../styles/images/plus.svg";

class AddGroup extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      groupPicture: friends,
      name: "",
      users: [],

      modals: {
        add: false,
      },
    };

    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleAddUsers = this.handleAddUsers.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];
    let reader = new FileReader();

    reader.onloadend = e => {
      this.safeSetState({ groupPicture: e.target.result });
    };
    if (file) reader.readAsDataURL(file);
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  mergeArraysNoDupplicates(...arrays) {
    console.log(arrays);
    let jointArray = [];

    arrays.forEach(array => {
      jointArray = [...jointArray, ...array];
    });
    return [...new Set([...jointArray])];
  }

  handleAddUsers(e, users) {
    this.safeSetState(
      prevState => ({
        users: prevState.users.concat(users),
      }),
      () => this.setModal("add", false)
    );
  }

  handleDeleteUser(e, user) {
    this.safeSetState(prevState => ({
      users: prevState.users.filter(u => u._id !== user._id),
    }));
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="addGroup"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={() => {
            this.safeSetState({
              users: [],
            });
          }}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate value="drivers_addGroup" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="picture-picker-container">
              <input
                id="file-picker"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.handlePictureChange}
              />
              <button type="button" className="picture-picker" onClick={this.handlePickPicture}>
                <img id="picture" src={this.state.groupPicture} alt="avatar" />
                <img src={camera} className="camera" alt="" />
              </button>
            </div>
            <form
              id="add-group-form"
              onSubmit={e => {
                this.props.onSubmit(e, this.state.groupPicture, this.state.users);
              }}
            >
              <div className="form-field">
                <p>
                  <Translate value="drivers_groupName" />
                </p>
                <input type="text" name="name" placeholder={I18n.t("drivers_groupNameExample")} />
              </div>
              <div className="form-field">
                {this.state.users.map(u => (
                  <UserCard
                    key={u._id}
                    type="info"
                    avatar={u.imageContent}
                    name={u.name || ""}
                    info={`${u.internationalPrefix} ${u.mobile}`}
                    onDelete={e => this.handleDeleteUser(e, u)}
                  />
                ))}
              </div>
              <div className="form-field">
                <button
                  type="button"
                  className="clear"
                  onClick={() => this.setModal("add", true)}
                  disabled={
                    this.props.isAdmin === false &&
                    this.state.users.length >= this.props.userPackage?.driversInGroupDriversLimit
                  }
                >
                  <img src={plus} alt="" />
                  <Translate value="drivers_addUser" />
                </button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="add-group-form">
              <Translate value="drivers_add" />
            </button>
          </Modal.Footer>
        </Modal>

        <AddUsers
          show={this.state.modals.add}
          onHide={() => this.setModal("add", false)}
          onAdd={this.handleAddUsers}
          listOfUsers={this.state.users}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, null)(AddGroup);
